import React from "react";

import { Lock, Loader2 } from "lucide-react";

import useModules from "../../hooks/useModules";
import MainContainer from "../MainContainer";

// Qual módulo cada rota exige. Precisa espelhar helpers/ModuleKeys do backend:
// é ele quem barra de fato — aqui só explicamos o porquê. Lista quer dizer
// "basta um deles", como o `modulo` do menu (MainListItems).
const MODULO_POR_ROTA = {
	"/campaigns": "campaigns",
	"/campaigns-config": "campaigns",
	"/campaigns-phrases": ["campaigns", "maturation"],
	"/contact-lists": "campaigns",
	"/maturacao": "maturation",
	"/flows": "flows",
	"/kanban": "kanban",
	"/personal-kanban": "kanban",
	"/internal-chat": "internalChat",
	"/scheduled-messages": "schedules",
	"/webhooks": "webhooks",
	"/reports": "reports",
	"/media-library": "mediaLibrary",
	"/zernio": "zernio",
	"/chamadas": "calls",
	"/gravacoes": "calls",
	"/ai": "ai",
	"/follow-ups": "followUp",
	"/messages-api": "externalApi",
	"/products": "erp",
	"/vendas": ["erp", "propostas"],
	"/propostas": "propostas",
	"/locacoes": "locacao",
	"/farmax": "farmax",
};

export const moduloDaRota = (caminho) => {
	const chave = Object.keys(MODULO_POR_ROTA).find(
		(prefixo) => caminho === prefixo || caminho.startsWith(`${prefixo}/`)
	);

	return chave ? MODULO_POR_ROTA[chave] : null;
};

// Sem o módulo contratado, a rota mostra o motivo em vez de uma tela vazia
// que parece defeito.
const ModuleGuard = ({ caminho, children }) => {
	const { temModulo, carregando } = useModules();

	const modulo = moduloDaRota(caminho);

	if (!modulo) return children;

	if (carregando) {
		return (
			<MainContainer>
				<div className="flex flex-1 items-center justify-center">
					<Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
				</div>
			</MainContainer>
		);
	}

	if ([].concat(modulo).some(temModulo)) return children;

	return (
		<MainContainer>
			<div className="flex flex-1 items-center justify-center p-6">
				<div className="max-w-sm text-center">
					<span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-muted">
						<Lock className="h-5 w-5 text-muted-foreground" />
					</span>
					<h2 className="mt-4 text-base font-semibold">
						Este recurso não está no seu plano
					</h2>
					<p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
						Fale com quem administra a sua conta para liberar. Ele pode ser
						adicionado sem trocar o plano inteiro.
					</p>
				</div>
			</div>
		</MainContainer>
	);
};

export default ModuleGuard;
